export class WorkspaceMetricsSettings {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": ""
        },
        {
            "name": "aws",
            "baseName": "aws",
            "type": "WorkspaceMetricsSettingsAws",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "WorkspaceMetricsSettingsGcp",
            "format": ""
        },
        {
            "name": "sparkMetricDenylistPrefixes",
            "baseName": "sparkMetricDenylistPrefixes",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return WorkspaceMetricsSettings.attributeTypeMap;
    }
    constructor() {
    }
}
